module.exports = __webpack_public_path__ + "static/media/home-banner-swirl.7daea57b.svg";